import React from 'react';
import { Meal } from '../../api/services/MealsService';
import { useTranslation } from '../../i18n/provider';
import styles from './FoodLogSection.module.css';

type Props = {
  title: string;
  meals: Meal[];
  goalCalories: number;
  goalProtein: number;
  goalCarbs: number;
  goalFats: number;
};

const FoodLogSection: React.FC<Props> = ({ title, meals, goalCalories, goalProtein, goalCarbs, goalFats }) => {
  const { t } = useTranslation();
  const totalCalories = meals.reduce((s, m) => s + m.calories, 0);
  const totalProtein = meals.reduce((s, m) => s + m.protein, 0);
  const totalCarbs = meals.reduce((s, m) => s + m.carbs, 0);
  const totalFats = meals.reduce((s, m) => s + m.fats, 0);

  const remainingCalories = goalCalories - totalCalories;
  const remainingProtein = goalProtein - totalProtein;
  const remainingCarbs = goalCarbs - totalCarbs;
  const remainingFats = goalFats - totalFats;

  const remainingLabel = remainingCalories >= 0 ? t('food.log.remaining') : t('food.log.over');

  return (
    <div className={styles.section}>
      <h3 className={styles.title}>{title}</h3>
      

      <div className={styles.card}>
        <div className={styles.list}>
          
        <div className={styles.rowWithBorder}>
        
          <div className={styles.totalsRow}>
            <div className={styles.totalsTitle}>{t('food.log.dailyTotal')}</div>
              <div className={styles.totalsRight}>
                <div>
                  <div className={styles.highlight}>{totalCalories} cal</div>
                </div>
                <div className={styles.highlightSmall}>P: {totalProtein}g</div>
                <div className={styles.highlightSmall}>C: {totalCarbs}g</div>
                <div className={styles.highlightSmall}>F: {totalFats}g</div>
              </div>
            </div>
            <div className={styles.remaining}>
              {remainingLabel}: {Math.abs(remainingCalories)} calories • P: {Math.abs(remainingProtein)}g • C: {Math.abs(remainingCarbs)}g • F: {Math.abs(remainingFats)}g
            </div>
          </div>
          {meals.length === 0 ? (
            <div className={styles.empty}>{t('food.log.noMeals')}</div>
          ) : (
            meals.map((m, idx) => (
              <div
                key={m.id}
                className={`${styles.row} ${idx === meals.length - 1 ? '' : styles.rowWithBorder}`}
              >
                <div>
                  <div className={styles.mealName}>{m.name}</div>
                  <div className={styles.mealLabel}>{m.label || t('food.log.today')}</div>
                </div>
                <div className={styles.right}>
                  <div className={styles.calories}>{m.calories} cal</div>
                  <div className={styles.macros}>P: {m.protein}g • C: {m.carbs}g • F: {m.fats}g</div>
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default FoodLogSection;
